import { Component, Input, OnInit } from '@angular/core'
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ParametreSpecfiqueBddEnedisDto } from '../../../data-access/http/dto/parametre-specfique-bdd-enedis-dto'
import { ParametreDto } from '../../../data-access/http/dto/parametre-dto'
import { ParametreService } from '../../../data-access/http/parametre.service'
import { ParametreSpecifiqueSaveDto } from '../../../data-access/http/dto/parametre-specifique-save-dto'
import { NotificationService } from 'src/app/parametre/data-access/http/notification.service'
import { SunleonService } from 'src/app/sunleon/data-access/http/sunleon.service'

@Component({
  selector: 'app-parametre-specifique-bdd-enedis-modal',
  templateUrl: './parametre-specifique-bdd-enedis-modal.component.html',
  styleUrls: ['./parametre-specifique-bdd-enedis-modal.component.scss']
})
export class ParametreSpecifiqueBddEnedisModalComponent implements OnInit {

  @Input()
  parametre: ParametreDto
  overloadable: boolean
  parametreTableauDto: ParametreSpecfiqueBddEnedisDto
  formGroup: FormGroup = this.formBuilder.group({})
  displayTableau: boolean = false
  formModalIsSubmitting: boolean = false
  isM0I = false
  m0iRows: Array<{ annee: string; valeur: string }> = []

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private parametreService: ParametreService,
    private sunLeonService: SunleonService,
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.isM0I = this.parametre.code === 'M0I'
    if (this.isM0I) {
      this.parametreService.getParametreByCode(this.parametre.code).subscribe((parametreDto) => {
        this.parametre = { ...this.parametre, ...parametreDto }
        this.m0iRows = this.parseM0IValue(this.parametre.valeur)
        this.formGroup.addControl('datas', this.generateM0IFormData(this.m0iRows))
        this.displayTableau = true
      })
      return
    }

    this.parametreService.getParametresBddEnedis(this.parametre.code).subscribe((parametreBddEnedis) => {
      this.parametreTableauDto = parametreBddEnedis
      this.formGroup.addControl('datas', this.generateFormData(parametreBddEnedis))
      this.displayTableau = true
    })
  }

  private generateFormData(parametreTableau: ParametreSpecfiqueBddEnedisDto): FormArray {
      const formArrayData = this.formBuilder.array([])
      for (const ligne of parametreTableau.lignes) {
        formArrayData.push(this.formBuilder.control(ligne.quotepart, Validators.required))
      }
      return formArrayData
  }

  getValidationMessage(index: number) {
    const control = (this.formGroup.get('datas') as FormArray).controls[index]
    if (control.hasError('required')) {
      return this.isM0I ? 'La valeur est obligatoire' : 'La quote-part est obligatoire'
    }
    return ''
  }

  // Cette fonction vérifie si le FormControl associé à l'indice donné est invalide
  isInvalidQuotePart(index: number) {
    const control = (this.formGroup.get('datas') as FormArray).controls[index]
    return control.invalid && (control.dirty || control.touched)
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      this.formModalIsSubmitting = true
      if (this.isM0I) {
        const newValue = this.buildM0IValue()
        this.parametre.valeur = newValue
        this.formModalIsSubmitting = false

        if (this.overloadable) {
          this.sunLeonService.saveOverloadableParametres(this.parametre.code, newValue)
          this.activeModal.dismiss({
            valeur: { parametreDto: this.parametre },
            utilisateur: this.parametre.utilisateur,
            dateModification: this.parametre.dateModification,
          })
        } else {
          this.modalService.dismissAll()
          this.parametreService.saveParametreTypeSimple(this.parametre, newValue).subscribe(
            {
              next: (data: any) => {
                const notif = this.notificationService.createNotification(this.parametre.id, this.parametre.code, this.parametre.type, "", "")
                notif.subscribe({
                  next: () => {},
                  error: () => {
                    this.toastr.error("Erreur lors de la crÃ©ation de la notification")
                  },
                })
                this.toastr.success('Le paramètre ' + this.parametre.code + ' a été enregistré avec succès.')
                this.activeModal.dismiss({
                  ...data,
                  parametreDto: {
                    ...this.parametre,
                    valeur: newValue,
                  },
                })
              },
              error: () => {
                this.toastr.error("Erreur lors de l'enregistrement du paramètre.")
                this.activeModal.dismiss()
              }
            }
          )
        }
        return
      }

      const dto:ParametreSpecifiqueSaveDto = this.revertData(this.parametreTableauDto)
      dto.parametreDto = this.parametre
      this.formModalIsSubmitting = false

      if (this.overloadable){
        this.sunLeonService.saveOverloadableParametresSpécifique(this.parametre, this.parametreTableauDto);
        dto.parametreDto.valeur = this.newValeurParametreSpecifique(this.parametreTableauDto)
        this.activeModal.dismiss({valeur: dto})

      } else {

        this.modalService.dismissAll()
        this.parametreService.saveParametreBddEnedis(this.parametre, this.parametreTableauDto).subscribe(
          {next:(data: any) => {
            const notif = this.notificationService.createNotification(this.parametre.id, this.parametre.code, this.parametre.type, "", "")
            notif.subscribe({
              next: () => {},
              error: () => {
                this.toastr.error("Erreur lors de la création de la notification")
              },
            })
            this.toastr.success('Le paramètre ' + this.parametre.code + ' a été enregistré avec succès.')
            this.formModalIsSubmitting = false
            this.activeModal.dismiss(data)
          },
          error:() => {
            this.toastr.error("Erreur lors de l'enregistrement du paramètre.")
            this.formModalIsSubmitting = false
            this.activeModal.dismiss()
          }}
        )
      }
    }
  }

  newValeurParametreSpecifique(parametreTableauSaveDto: ParametreSpecfiqueBddEnedisDto): string {
    let sNewParametre = '';

    for (const ligne of parametreTableauSaveDto.lignes) {
      sNewParametre += `[${ligne.codedepartement}]=${ligne.quotepart};`;
    }

    return sNewParametre;
  }

  revertData(datas: ParametreSpecfiqueBddEnedisDto):ParametreSpecifiqueSaveDto {
    const result = []
    for (let i = 0; i < datas.lignes.length; i++) {
      datas.lignes[i].quotepart = this.formGroup.value.datas[i]
      result.push(datas.lignes[i])
    }
    return { ...datas, datas: result }
  }

  fermerModal(): void {
    // Fermez le modal en appelant la méthode close sur l'objet MatDialogRef
    this.activeModal.dismiss()
  }

  private parseM0IValue(value: string | null | undefined): Array<{ annee: string; valeur: string }> {
    if (!value) {
      return []
    }

    return value
      .split(';')
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .map((item) => {
        const match = item.match(/^\[(.+?)\]\s*=\s*(.+)$/)
        if (!match) {
          return null
        }
        return {
          annee: match[1].trim(),
          valeur: match[2].trim(),
        }
      })
      .filter((item): item is { annee: string; valeur: string } => item !== null)
  }

  private generateM0IFormData(rows: Array<{ annee: string; valeur: string }>): FormArray {
    const formArrayData = this.formBuilder.array([])
    rows.forEach((row) => {
      formArrayData.push(this.formBuilder.control(row.valeur, Validators.required))
    })
    return formArrayData
  }

  private buildM0IValue(): string {
    return this.m0iRows
      .map((row, index) => `[${row.annee}]=${this.formGroup.value.datas[index]};`)
      .join('')
  }
}
